import * as React from 'react';

const uid = (): string =>
  Math.random()
    .toString(36)
    .substring(2);

const ANIMATION_SPEED = 2;
const PRIMARY_COLOR = '#f3f3f3';
const SECONDARY_COLOR = '#ecebeb';

export type ContentLoaderProps = {
  children?: React.ReactNode;
  /** Optional class name to attach to the content loader */

  className?: string;
  /** Overall height of loader */

  height?: string;
  /** Overall width of loader */

  width?: string;
};

export const defaultProps = {
  height: '100px',
  width: '100%',
};

// Example usage:
// ```
// <ContentLoader height="100px">
//   <rect x="16" y="14" rx="0" ry="0" width="33" height="33" />
//   <rect x="72" y="14" rx="0" ry="0" width="33" height="33" />
//   <rect x="130" y="14" rx="0" ry="0" width="50%" height="15" />
//   <rect x="130" y="40" rx="0" ry="0" width="70%" height="13" />
//   <rect x="130" y="58" rx="0" ry="0" width="40%" height="13" />
// </ContentLoader>
// ```

const ContentLoader: React.FC<ContentLoaderProps> = props => {
  const idClip = uid();
  const idGradient = 'content-loader-gradient';
  return (
    <svg
      style={{
        height: props.height,
        verticalAlign: 'top',
        width: props.width,
      }}
      version="1.1"
    >
      <rect
        clipPath={`url(#${idClip})`}
        height={props.height}
        style={{
          fill: `url(#${idGradient})`,
        }}
        width={props.width}
        x="0"
        y="0"
      />

      <defs>
        <clipPath id={idClip}>{props.children}</clipPath>

        <linearGradient id={idGradient}>
          <stop offset="0%" stopColor={PRIMARY_COLOR} stopOpacity={1}>
            <animate
              attributeName="offset"
              dur={`${ANIMATION_SPEED}s`}
              repeatCount="indefinite"
              values="-2; 1"
            />
          </stop>
          <stop offset="50%" stopColor={SECONDARY_COLOR} stopOpacity={1}>
            <animate
              attributeName="offset"
              dur={`${ANIMATION_SPEED}s`}
              repeatCount="indefinite"
              values="-1.5; 1.5"
            />
          </stop>
          <stop offset="100%" stopColor={PRIMARY_COLOR} stopOpacity={1}>
            <animate
              attributeName="offset"
              dur={`${ANIMATION_SPEED}s`}
              repeatCount="indefinite"
              values="-1; 2"
            />
          </stop>
        </linearGradient>
      </defs>
    </svg>
  );
};

ContentLoader.defaultProps = defaultProps;

export default ContentLoader;
